import { ITranslation } from "@shared/utils/helpers/translation.interface";

export interface ICartItem {
  id: number;
  serviceRequestTemplateID: string;
  externalID?: string;
  name: string;
  description?: string;
  pricePerUnit: IPriceResponse;
  availableShippingTypes: ShippingType[];
  shippingAddress?: string | null;
  shippingType?: ShippingType;
  prescriptionRequired: boolean;
  status: ServiceRequestOrderStatus;
  paymentStatus: ServiceRequestPaymentStatus;
}

export interface INewCartItem {
  serviceRequestID: string;
  riskTemplateID: string;
}

// TODO GLOR-194: Possible d'ajouter name, description, pricePerUnit ? ca éviterais l'appel a getCartItems
export interface IExposedRequestInOrder {
  id: number;
  orderID: number;
  requestID: string;
  riskID: string;
  externalID?: string;
  subscriptionID?: string;
  shippingAddress?: string;
  shippingType?: string;
  paidAmount?: number;
  paidUntil?: string;
  status: ServiceRequestOrderStatus;
  paymentStatus: ServiceRequestPaymentStatus;
}

export interface IAddToCartErrorResponse {
  error: string;
  required?: IAddToCartExceptionPayload;
}

export interface IAddToCartExceptionPayload {
  dna: string;
  message?: ITranslation;
  risk: string;
}

export enum CartExceptionEnum {
  DNA_NOT_DECODED = "DNA_NOT_DECODED",
  ITEM_ALREADY_IN_CART = "ITEM_ALREADY_IN_CART",
  SERVICE_ALREADY_SUBSCRIBED = "SERVICE_ALREADY_SUBSCRIBED",
}

export interface IAddToCartErrorDialogData {
  errors: IAddToCartGroupedError[];
  required?: IAddToCartExceptionPayload;
}

export interface IAddToCartResult {
  status: "success" | "conflict" | "error";
  name: string;
  item: INewCartItem;
  error?: IAddToCartErrorResponse;
}

export interface IAddToCartGroupedError {
  code: string;
  items: IGroupedCartItem[];
}

export interface IGroupedCartItem {
  item: INewCartItem;
  name: string;
}

export interface IPriceResponse {
  value: number;
  currency: string;
  timing?: ITiming;
}

export interface ITiming {
  period: number;
  periodUnit: string;
}

export enum ShippingType {
  USER_ADDRESS = "USER_ADDRESS",
  RELAY_POINT = "RELAY_POINT",
}

export enum ServiceRequestOrderStatus {
  NOT_ORDERED = "NOT_ORDERED",
  ORDERED = "ORDERED",
  IN_TRANSIT = "IN_TRANSIT",
  SAMPLE_RECEIVED = "SAMPLE_RECEIVED",
  SAMPLE_REJECTED = "SAMPLE_REJECTED",
  IN_ANALYSIS = "IN_ANALYSIS",
  ANALYSIS_FAILED = "ANALYSIS_FAILED",
  ANALYSIS_COMPLETED = "ANALYSIS_COMPLETED",
  RESULTS_AVAILABLE = "RESULTS_AVAILABLE",
}

export enum ServiceRequestPaymentStatus {
  NOT_PAID = "NOT_PAID",
  PENDING = "PENDING",
  PAID = "PAID",
  PAST_DUE = "PAST_DUE", // subscription only: renewal failed, in grace period
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
}
